import { render, staticRenderFns } from "./ImageGrid.vue?vue&type=template&id=2c58eb00&scoped=true&"
import script from "./ImageGrid.vue?vue&type=script&lang=js&"
export * from "./ImageGrid.vue?vue&type=script&lang=js&"
import style0 from "./ImageGrid.vue?vue&type=style&index=0&id=2c58eb00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58eb00",
  null
  
)

export default component.exports